import { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { CookieHelper } from "@jnpmedi/helper-session";
import { createPortal } from "react-dom";
import { setLocalStorageDocsVersion } from "@newHooks/common/useDocsVersion";
import { useReleaseHistoriesQuery } from "@newHooks/query/release/releaseHistories.query";
import { NoticePopup } from "./NoticePopup";
import { ReleasePopup } from "./ReleasePopup";
import { getCurrentDate } from "@maven-helper/functions/Misc.function";
import dayjs from "dayjs";

export const DOCS_NOTICE_POPUP_KEY = (id: bigint) => `docs:notice:popup:key:${id}`;
export const DOCS_RELEASE_POPUP_KEY = "docs:release:popup:key";
export const DOCS_POPUP_DATE_FORMAT = "YYYY/MM/DD";

export function Popup() {
  const [showNoticePopups, setShowNoticePopups] = useState<Map<bigint, boolean>>(new Map());
  const [showReleasePopup, setShowReleasePopup] = useState<boolean>(false);

  const handleNoticePopupClose = (noticeId: bigint) => {
    setShowNoticePopups((prev) => {
      const newShowNoticePopups = new Map(prev);
      newShowNoticePopups.set(noticeId, false);

      return newShowNoticePopups;
    });
  };

  const { data, isLoading } = useReleaseHistoriesQuery({
    onSuccess: ({ notices, release }) => {
      if (notices?.length) {
        const showNoticePopupMap: Map<bigint, boolean> = new Map();

        notices.forEach(({ id }) => {
          const existDate = CookieHelper.getCookie(DOCS_NOTICE_POPUP_KEY(id));

          showNoticePopupMap.set(id, existDate ? !dayjs(getCurrentDate()).isSame(existDate, "day") : true);
        });

        setShowNoticePopups(showNoticePopupMap);
      }

      if (release) {
        const existVersion = CookieHelper.getCookie(DOCS_RELEASE_POPUP_KEY) ?? "";
        setLocalStorageDocsVersion(release.version);
        setShowReleasePopup(release.version !== existVersion);
      }
    },
  });

  useEffect(() => {
    document.body.style.overflow =
      Array.from(showNoticePopups.values()).some((isShow) => isShow) || showReleasePopup ? "hidden" : "visible";
  }, [showNoticePopups, showReleasePopup]);

  return (
    <>
      {!isLoading &&
        (Array.from(showNoticePopups.values()).some((isShow) => isShow) || showReleasePopup) &&
        createPortal(
          <StyledBackgroundWrapper>
            {data?.notices?.length &&
              data.notices.map(
                (notice) =>
                  !!showNoticePopups.get(notice.id) && <NoticePopup key={`${notice.id}`} notice={notice} onClose={handleNoticePopupClose} />
              )}
            {data?.release && showReleasePopup && <ReleasePopup release={data.release} onClose={() => setShowReleasePopup(false)} />}
          </StyledBackgroundWrapper>,
          document.body
        )}
    </>
  );
}

const StyledBackgroundWrapper = styled("div")({
  zIndex: 999999,
  position: "absolute",
  top: "0px",
  left: "0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "2rem",
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.3)",
});
